// https://ckeditor.com/docs/ckeditor4/latest/guide/dev_webpack.html

window.CKEDITOR_BASEPATH = '/dist/ckeditor4/';
